var map = {
	"./de-DE/layout": 4767,
	"./en-US/layout": 23153,
	"./fr-FR/layout": 38210,
	"./ja-JP/layout": 64609,
	"./ko-KR/layout": 79372,
	"./pl-PL/layout": 62135,
	"./pt-BR/layout": 28657,
	"./ro-RO/layout": 43371,
	"./uk-UA/layout": 70042,
	"./vi-VN/layout": 60464,
	"./zh-Hans/layout": 54679,
	"./zh-Hant/layout": 62438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68012;